module.exports = __webpack_public_path__ + "static/media/027_g4_2Choose Tickets.8645bf49.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/gigable/027_g4_2Choose Tickets.png
// module id = 446
// module chunks = 0